module.exports = __webpack_public_path__ + "img/页面图片修改2-4.6248c471.png";